"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbag = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 49",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbag` : '') + (description ? ` desc-brandedbag` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbag"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbag"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 29.5v-19a7.5 7.5 0 0 0-15 0v19a7.5 7.5 0 0 0 15 0ZM27.5 0C21.7 0 17 4.7 17 10.5v19a10.5 10.5 0 1 0 21 0v-19C38 4.7 33.3 0 27.5 0Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.92 13.23c.17-.53.06-1.1-.27-1.53-.34-.44-.87-.7-1.44-.7H1.8c-.57 0-1.1.26-1.44.7-.33.44-.44 1-.27 1.53L9.5 48c.23.73.83 1 1.62 1h33.29c.79 0 1.48-.5 1.71-1.23l9.8-34.54Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m.03 13 8.7 32.1C21 38.25 32.5 31.1 48 11H2.04c-1.7-.04-2.08 1.3-2.01 2Z",
    fill: "#F8985A"
  }));
};
var _default = exports.default = brandedbag;